import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientDashboardPage from "@/pages/client/ClientDashboardPage";

export const Route = createFileRoute("/client/dashboard")({
  head: () => pageHead("Client · Dashboard", "AKIVA client · dashboard portal.", "/client/dashboard", true),
  component: ClientDashboardPage,
});
